// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__36TpO","inputWrap":"CustomTip_inputWrap__1Xwqv"};